import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import MarketingHeader from "@/components/marketing/Header";
import MarketingFooter from "@/components/marketing/Footer";
import api from "@/lib/api";
import { ArrowRight } from "lucide-react";

export default function News() {
  const [posts, setPosts] = useState([]);
  useEffect(() => {
    api.get("/posts").then((r) => setPosts(r.data)).catch(() => {});
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <MarketingHeader />
      <section className="bg-[#0a2540] text-white">
        <div className="max-w-7xl mx-auto px-6 py-24">
          <h1 className="font-display text-4xl sm:text-5xl font-light">News & Updates</h1>
          <p className="mt-4 text-white/70 max-w-2xl">Product updates, language coverage and stories from the field.</p>
        </div>
      </section>
      <section className="max-w-7xl mx-auto px-6 py-20">
        {posts.length === 0 && (
          <p className="text-slate-400 text-center py-16">No posts published yet.</p>
        )}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="news-list">
          {posts.map((p) => (
            <Link key={p.slug} to={`/news/${p.slug}`} data-testid={`news-post-${p.slug}`}
              className="border border-slate-200 rounded-2xl p-7 bg-white hover:shadow-lg transition-shadow block">
              <div className="text-xs text-slate-400">{new Date(p.created_at).toLocaleDateString()}</div>
              <h3 className="mt-2 font-display text-xl font-medium text-[#0a2540] leading-snug">{p.title}</h3>
              <p className="mt-2 text-sm text-slate-600 line-clamp-3">{p.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-1 text-sm text-teal-600 font-medium">
                Read <ArrowRight className="h-4 w-4" />
              </span>
            </Link>
          ))}
        </div>
      </section>
      <MarketingFooter />
    </div>
  );
}
